import React from 'react';
import RestaurantIcon from '@menuzen/icon/build/outline/Restaurant';
import ThemeIcon from '@menuzen/icon/build/outline/Theme';
import PlusSquareIcon from '@menuzen/icon/build/outline/PlusSquare';
import { MODAL } from './modals/config';

interface NavBarProps {
    onClickItem: (tab: string) => void;
}

const NavBar: React.FC<NavBarProps> = ({ onClickItem }) => {
    return (
        <div className="py-20 flex items-center justify-center space-x-30">
            <button onClick={() => onClickItem(MODAL.PROFILE_SETTING)}>
                <div className="w-50 flex flex-col items-center justify-center">
                    <div className="text-20 text-primary-80">
                        <RestaurantIcon />
                    </div>
                    <div className="font-bold text-10 text-primary-80">Profile</div>
                </div>
            </button>
            <button
                className="w-50 flex flex-col items-center justify-center"
                onClick={() => onClickItem(MODAL.BLOCK_SETTING)}
            >
                <div className="text-20 text-primary-80">
                    <PlusSquareIcon />
                </div>
                <div className="font-bold text-10 text-primary-80">Blocks</div>
            </button>
            <button
                className="w-50 flex flex-col items-center justify-center"
                onClick={() => onClickItem(MODAL.DESIGN_SETTING)}
            >
                <div className="text-20 text-primary-80">
                    <ThemeIcon />
                </div>
                <div className="font-bold text-10 text-primary-80">Design</div>
            </button>
        </div>
    );
};

export default NavBar;
